<div
  class="checkin__input__container"
  [ngClass]="{ 'checkin__input__container--disabled' : disabled }"
  *ngIf="!isClientSupportNumber || (clientIdType == 'D' || clientIdType == 'N')"
  [formGroup]="form">
  <label *ngIf="label" [ngClass]="{ 'checkin__input__label--disabled' : disabled }">
    {{ label | translate }}
    <span class="checkin__input--required" *ngIf="label && (required || (isClientSupportNumber && accSpanish && (clientIdType == 'D' || clientIdType == 'N')))">*</span>
    <app-tooltip
      *ngIf="tooltip"
      [disabled]="disabled"
      [text]="tooltip">
    </app-tooltip>
  </label>
  <input
    class="checkin__input"
    [ngClass]="customClass"
    [maxLength]="maxLength"
    [placeholder]="placeholder | translate"
    type="text"
    [formControlName]="control"
    (focus)="onFocus()"
    (blur)="onBlur()"/>
  <span
    *ngIf="showErrorText"
    class="checkin__input--error">{{ errorMsg | translate }}</span>

    <app-request-interface-input
      [showLoadingSave]="showLoadingSave"
      [result]="requestSaveType"
      [sizeLoader]="16">
    </app-request-interface-input>
</div>
